import { render, staticRenderFns } from "./MultipleBox.vue?vue&type=template&id=3b65dbb3&scoped=true"
import script from "./MultipleBox.vue?vue&type=script&lang=js"
export * from "./MultipleBox.vue?vue&type=script&lang=js"
import style0 from "./MultipleBox.vue?vue&type=style&index=0&id=3b65dbb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b65dbb3",
  null
  
)

export default component.exports